import shop from './shop'
import misc from './misc'

const widgetDefinitions = {
  shop,
  misc,
}

export default widgetDefinitions
